import {
  CcfBox,
  CcfEditPenIcon,
  CcfHyperlinkIcon,
  CcfTooltip,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './simulator-v2-external-data-tab.module.scss';
import {
  Card,
  CardContent,
  FormControlLabel,
  IconButton,
  Link,
  Switch,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  getSelectedContact,
  updateselectedContact,
} from '../../+state/simulatorV2.slice';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { Button } from 'antd';
import EditDialogBox from '../../utils/editDialogBox';
import { generateDate } from '../../utils/utils';

/* eslint-disable-next-line */
export interface SimulatorV2ExternalDataTabProps {
  setUpdatedContact: any;
  updatedContact: any;
}

/**
 * used to show the External Data Tab
 * @param props - SimulatorV2ExternalDataTabProps
 * @example ` <SimulatorV2ExternalDataTab />`
 */
export function SimulatorV2ExternalDataTab(
  props: SimulatorV2ExternalDataTabProps
) {
  const { setUpdatedContact, updatedContact } = props;
  const dispatch = useDispatch();
  const activeContact = useSelector(getSelectedContact);
  const [editCustomerDetails, setEditCustomerDetails] = useState(
    activeContact?.customer
  );
  const [currentRecord, setCurrentRecord] = useState(
    activeContact?.recentInteraction[0]
  );
  const [relatedRecords, setRelatedRecords] = useState(
    activeContact?.recentInteraction.slice(1)
  );

  const [editCurrentRecord, setEditCurrentRecord] = useState(false);
  const [editRelatedRecord, setEditRelatedRecord] = useState(false);
  dayjs.extend(utc);
  dayjs.extend(advancedFormat);

  /**@example */
  const handleCloseModal = () => {
    setEditCurrentRecord(false);
    setEditRelatedRecord(false);
  };

  useEffect(() => {
    setUpdatedContact({
      ...updatedContact,
      lastUpdatedDate: generateDate(),
      recentInteraction: [
        { ...currentRecord },
        ...relatedRecords.map((record: any) => ({
          ...record,
        })),
      ],
    });
  }, [currentRecord, relatedRecords]);

  /**@example */
  const handleSave = (newItem: any, type: any) => {
    const updatedRecord = Object.keys(newItem).reduce((acc: any, key: any) => {
      acc[key] = newItem[key] !== undefined ? newItem[key] : currentRecord[key];
      return acc;
    }, {});
    if (newItem.recordType === 'current_record') {
      setCurrentRecord({ ...currentRecord, ...updatedRecord });
    } else {
      setRelatedRecords(
        relatedRecords.map((record: any) =>
          record.id === newItem.id ? { ...record, ...updatedRecord } : record
        )
      );
    }
    setEditCurrentRecord(false);
    setEditRelatedRecord(false);
  };

  /**@example */
  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    label: string
  ) => {
    const details = {
      ...editCustomerDetails,
      [label]: event,
    };
    setEditCustomerDetails(details);
    setUpdatedContact({
      ...updatedContact,
      lastUpdatedDate: generateDate(),
      customer: {
        ...updatedContact.customer,
        ...details,
      },
    });
    dispatch(updateselectedContact({ field: label, value: event }));
  };

  return (
    <div className={styles['container']}>
      <CcfBox
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
        }}
      >
        <CcfTypography className={styles.headerText}>
          External Data
        </CcfTypography>
        <CcfBox className={styles.switchSubContainer}>
          <FormControlLabel
            label="Show External Data Loyalty Card Section"
            labelPlacement="start"
            control={
              <Switch
                // id="sm_contactDetails_botTranscript"
                name="Show External Data Loyalty Card Section"
                color="primary"
                checked={editCustomerDetails?.externalDataLoyaltyInfoHide}
                sx={{
                  ' .MuiFormControlLabel-label': {
                    width: 165,
                  },
                }}
                onChange={(event: any) =>
                  handleCheckboxChange(
                    event.target.checked,
                    'externalDataLoyaltyInfoHide'
                  )
                }
              />
            }
            style={{
              marginLeft: 0,
              display: 'flex',
              justifyContent: 'space-between',
              width: '25.5rem',
            }}
            className={styles.label}
          />{' '}
          <FormControlLabel
            label="Show Tickets Tab"
            labelPlacement="start"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '25.5rem',
              marginLeft: 0,
            }}
            className={styles.label}
            control={
              <Switch
                // id="sm_contactDetails_botTranscript"
                name="Show Tickets Tab"
                color="primary"
                checked={editCustomerDetails?.consumerCardTicketTabHide}
                sx={{
                  ' .MuiFormControlLabel-label': {
                    width: 175,
                  },
                }}
                onChange={(event: any) =>
                  handleCheckboxChange(
                    event.target.checked,
                    'consumerCardTicketTabHide'
                  )
                }
              />
            }
          />{' '}
        </CcfBox>
        <CcfBox className={styles.subContainer1}>
          <CcfBox className={styles.subContainer}>
            <CcfTypography className={styles.subHeaderText}>
              Current Record
            </CcfTypography>
          </CcfBox>
          <Card
            variant="outlined"
            style={{ marginBottom: '5px', cursor: 'pointer' }}
          >
            <CardContent className={styles.recordContent}>
              <CcfBox className={styles.recordDetailsBlock}>
                <CcfBox className={styles.recordMinParentContainer}>
                  <CcfBox className={styles.recordDetails}>
                    <CcfBox className={styles.editDetailsHeader}>
                      <CcfTypography className={styles.caseTitle}>
                        {
                          currentRecord.label
                            .split(',')
                            .map((part: any) => part.trim())[0]
                        }{' '}
                        {`${
                          currentRecord.label
                            .split(',')
                            .map((part: any) => part.trim())[1]
                        }`}
                      </CcfTypography>
                      <Button
                        style={{ border: 'none' }}
                        onClick={() => setEditCurrentRecord(true)}
                      >
                        <CcfEditPenIcon
                          viewBox="3 0 20 20"
                          fillColor="#000000"
                        />
                      </Button>
                    </CcfBox>
                    <CcfBox style={{ display: 'flex', gap: '5px' }}>
                      <CcfBox className={styles.linkIcon}>
                        <IconButton
                          style={{ padding: '0px' }}
                          id={`agent_appSpace_externalTab_hyperLink`}
                        >
                          <CcfHyperlinkIcon
                            fillColor="#ffffff"
                            className={styles.articleIcon}
                          />
                        </IconButton>{' '}
                      </CcfBox>
                      <div
                        style={{ height: '25px' }}
                        id={`agent_appSpace_externalDataTab_nowContact`}
                      >
                        <CcfTooltip
                          title="ServiceNow 2 Contact"
                          arrow
                          placement="top"
                          styles={{
                            ccfTooltipArrow: {
                              color: 'white',
                            },
                            ccfTooltip: {
                              borderRadius: '6px',
                              backgroundColor: 'white',
                              boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 30%)',
                              color: 'black',
                            },
                          }}
                        >
                          <div>
                            <img
                              src={`${currentRecord.crmIcon}`}
                              style={{ width: '70px', height: '25px' }}
                              alt={'nowCase'}
                            />
                          </div>
                        </CcfTooltip>
                      </div>
                    </CcfBox>
                    <CcfBox
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                      }}
                    >
                      <CcfTypography
                        style={{
                          color: '#767676',
                          fontWeight: '600',
                          fontSize: '11px',
                        }}
                      >
                        {`priority : `}
                      </CcfTypography>
                      <CcfTypography
                        className={styles.statusText}
                        translationKey={currentRecord.status}
                      ></CcfTypography>
                    </CcfBox>
                    <CcfTypography
                      style={{
                        color: '#767676',
                        fontWeight: '400',
                        fontSize: '12px',
                      }}
                    >
                      {`${dayjs(currentRecord.date)
                        .utc()
                        .format('MM/DD/YYYY hh:mm A')} | ${
                        currentRecord.details
                      }`}
                    </CcfTypography>
                  </CcfBox>{' '}
                </CcfBox>
              </CcfBox>
            </CardContent>
          </Card>
          {editCurrentRecord && (
            <EditDialogBox
              isOpen={editCurrentRecord}
              handleClose={handleCloseModal}
              modalHeader="Edit Record"
              notRequiredFields={['id', 'isCopy', 'recordType']}
              modalData={{
                ...currentRecord,
              }}
              modalDataType="edit"
              onSave={handleSave}
            />
          )}
        </CcfBox>
        <CcfBox className={styles.subContainer1}>
          <CcfBox className={styles.subContainer}>
            <CcfTypography
              translationKey={activeContact?.recentInteraction[1].recordType}
              className={styles.subHeaderText}
            ></CcfTypography>{' '}
          </CcfBox>
          {relatedRecords.map((record: any, i: any = 1) => (
            <>
              <Card
                variant="outlined"
                style={{ marginBottom: '5px', cursor: 'pointer' }}
              >
                <CardContent className={styles.recordContent}>
                  <CcfBox className={styles.recordDetailsBlock}>
                    <CcfBox className={styles.recordMinParentContainer}>
                      <CcfBox className={styles.recordDetails}>
                        <CcfBox className={styles.editDetailsHeader}>
                          <CcfTypography className={styles.caseTitle}>
                            {
                              record.label
                                .split(',')
                                .map((part: any) => part.trim())[0]
                            }{' '}
                            {`${
                              record.label
                                .split(',')
                                .map((part: any) => part.trim())[1]
                            }`}
                          </CcfTypography>
                          <Button
                            style={{ border: 'none' }}
                            onClick={() => setEditRelatedRecord(i)}
                          >
                            <CcfEditPenIcon
                              viewBox="3 0 20 20"
                              fillColor="#000000"
                            />
                          </Button>
                        </CcfBox>
                        <CcfBox style={{ display: 'flex', gap: '5px' }}>
                          <CcfBox
                            className={
                              record.isCopy
                                ? styles.linkIcon
                                : styles.greenStatus
                            }
                          >
                            <IconButton
                              style={{ padding: '0px' }}
                              id={`agent_appSpace_externalTab_hyperLink`}
                            >
                              <CcfHyperlinkIcon
                                fillColor="#ffffff"
                                className={styles.articleIcon}
                              />
                            </IconButton>{' '}
                          </CcfBox>
                          <div
                            style={{ height: '25px' }}
                            id={`agent_appSpace_externalDataTab_nowContact`}
                          >
                            <CcfTooltip
                              title="ServiceNow 2 Contact"
                              arrow
                              placement="top"
                              styles={{
                                ccfTooltipArrow: {
                                  color: 'white',
                                },
                                ccfTooltip: {
                                  borderRadius: '6px',
                                  backgroundColor: 'white',
                                  boxShadow:
                                    '0px 5px 15px 0px rgb(0 0 0 / 30%)',
                                  color: 'black',
                                },
                              }}
                            >
                              <div>
                                <Link
                                  target="_blank"
                                  href={`${record.crmUrl}`}
                                  underline="none"
                                  rel="noreferrer"
                                >
                                  <img
                                    src={`${record.crmIcon}`}
                                    style={{ width: '70px', height: '25px' }}
                                    alt={'nowCase'}
                                  />
                                </Link>
                              </div>
                            </CcfTooltip>
                          </div>
                        </CcfBox>
                        <CcfBox
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                          }}
                        >
                          <CcfTypography
                            className={styles.closedText}
                            translationKey={record.status}
                          ></CcfTypography>
                        </CcfBox>
                        <span
                          style={{
                            color: '#767676',
                            fontWeight: '400',
                            fontSize: '12px',
                          }}
                        >
                          {dayjs(record.date)
                            .utc()
                            .format('MM/DD/YYYY hh:mm A')}{' '}
                          | {record.details}
                        </span>
                      </CcfBox>{' '}
                    </CcfBox>
                  </CcfBox>
                </CardContent>
              </Card>

              {editRelatedRecord === i && (
                <EditDialogBox
                  isOpen={editRelatedRecord === i}
                  handleClose={handleCloseModal}
                  modalHeader="Edit Record"
                  notRequiredFields={['id', 'isCopy', 'recordType']}
                  modalData={{
                    ...relatedRecords[i],
                  }}
                  modalDataType="edit"
                  onSave={handleSave}
                />
              )}
            </>
          ))}
        </CcfBox>
      </CcfBox>
    </div>
  );
}

export default SimulatorV2ExternalDataTab;
